import { render, staticRenderFns } from "./naj-nafath-otp-input.vue?vue&type=template&id=790992aa&scoped=true&"
import script from "./naj-nafath-otp-input.vue?vue&type=script&lang=js&"
export * from "./naj-nafath-otp-input.vue?vue&type=script&lang=js&"
import style0 from "./naj-nafath-otp-input.vue?vue&type=style&index=0&id=790992aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790992aa",
  null
  
)

export default component.exports